// extracted by mini-css-extract-plugin
export default {"numeric":"RecipientCountDisplay_numeric__lsrjM"};